/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Scattered_DescriptionInputs */

const en_why_listening_scattered_description = /** @type {(inputs: Why_Listening_Scattered_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One reader for papers, one for articles and newsletters, one for everything else. Three apps, three subscriptions, and citations still read aloud in the middle of a sentence.`)
};

const es_why_listening_scattered_description = /** @type {(inputs: Why_Listening_Scattered_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un lector para artículos académicos, otro para artículos y newsletters, otro para todo lo demás. Tres apps, tres suscripciones y citas leídas en voz alta en mitad de una frase.`)
};

/**
* | output |
* | --- |
* | "One reader for papers, one for articles and newsletters, one for everything else. Three apps, three subscriptions, and citations still read aloud in the midd..." |
*
* @param {Why_Listening_Scattered_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_scattered_description = /** @type {((inputs?: Why_Listening_Scattered_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Scattered_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_scattered_description(inputs)
	return en_why_listening_scattered_description(inputs)
});